import type { JSX } from 'react';
import {
  DocumentPdfRegular,
  DocumentRegular,
  DocumentTableRegular,
  DocumentTextRegular,
  FolderZipRegular,
  ImageRegular,
} from '@fluentui/react-icons';
import { getFileExtension } from './fileName';

const FILE_TYPE_ICONS: Record<string, () => JSX.Element> = {
  pdf: () => <DocumentPdfRegular />,
  doc: () => <DocumentTextRegular />,
  docx: () => <DocumentTextRegular />,
  txt: () => <DocumentTextRegular />,
  rtf: () => <DocumentTextRegular />,
  ppt: () => <DocumentTextRegular />,
  pptx: () => <DocumentTextRegular />,
  xls: () => <DocumentTableRegular />,
  xlsx: () => <DocumentTableRegular />,
  csv: () => <DocumentTableRegular />,
  jpg: () => <ImageRegular />,
  jpeg: () => <ImageRegular />,
  png: () => <ImageRegular />,
  gif: () => <ImageRegular />,
  webp: () => <ImageRegular />,
  svg: () => <ImageRegular />,
  zip: () => <FolderZipRegular />,
  rar: () => <FolderZipRegular />,
  '7z': () => <FolderZipRegular />,
};

export const getFileTypeIcon = (nameOrUrl: string): JSX.Element => {
  const ext = getFileExtension(nameOrUrl);
  return FILE_TYPE_ICONS[ext]?.() ?? <DocumentRegular />;
};
